export default {
  title: "Warlock",
  content: [
    "New ability: Soulshatter: Reduces threat by 100% for all enemies within 40 yards. Reagents: Soul Shard. 5 min cooldown.",
    "Firestone reworked: when equipped, increases fire damage and causes your Searing Pain to cause no additional threat. When used, greatly increases your fire damage for 8 sec. ",
    "Spellstone now increases your critical strike chance by 3% while equipped.",
    "Life Tap now grants more mana at the cost of health.",
    "Increased the health restored by Demon Armor.",
    "All demons will now receive a percentage of their master's stats and their spell damage and attack power is increased by a percentage of their master’s spell damage.",
    "Increased Soul Shards stack size.",
  ],
};
